export default __webpack_public_path__ + "static/media/Maximize.94610484.svg";